import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Support() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // For MVP: log only. Wire up email/CRM later.
    setSent(true);
    toast.success("Message received. We'll reply within 24h.");
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">Support</div>
          <h1 className="font-display text-4xl mb-4">Get in touch.</h1>
          <p className="text-slate-600 mb-8">We&apos;re here to help with anything from account questions to dispute resolution.</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><EnvelopeSimple size={18} className="text-brand" /> support@quickjobs.ca</li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-brand" /> 1-855-QJOBS-CA</li>
            <li className="flex items-center gap-3"><MapPin size={18} className="text-brand" /> Toronto, ON, Canada</li>
          </ul>
        </div>
        <form onSubmit={submit} className="border border-slate-200 p-6 space-y-4">
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" className="w-full border border-slate-300 px-3 py-2.5" data-testid="support-name" />
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="w-full border border-slate-300 px-3 py-2.5" data-testid="support-email" />
          <input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="Subject" className="w-full border border-slate-300 px-3 py-2.5" data-testid="support-subject" />
          <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="How can we help?" className="w-full border border-slate-300 px-3 py-2.5" data-testid="support-message" />
          <button type="submit" disabled={sent} className="bg-brand text-white px-5 py-2.5 font-semibold disabled:opacity-50" data-testid="support-submit">
            {sent ? "Sent" : "Send message"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
